export const AMAZON_USA = "AMAZON_USA";
export const AMAZON_SPAIN = "AMAZON_SPAIN";
